import Vue from 'vue';
import { assign, find, each, isEmpty, findIndex } from 'lodash';
import * as api from 'api/api-programs';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
};

const state = {};

const addScheduleInList = (data, schedule) => {
  const timeFromList = find(data, item => item.Time === schedule.Time);
  if (timeFromList) {
    timeFromList.Schedules.push(schedule.Schedules[0]);
  } else {
    data.push(schedule);
  }
};

const editScheduleInList = (data, schedule) => {
  console.log('editScheduleInList', data, schedule);
  each(data, (stateSchedule, stateIndex) => {
    const index = findIndex(stateSchedule.Schedules, item => item.id === schedule.Schedules[0].id);
    if (index !== -1) {
      // is time changed remove it from time and put in new time
      if (stateSchedule.Time !== schedule.Time) {
        // remove changed schedule
        stateSchedule.Schedules.splice(index, 1);
        // if schedules list for finded time empty remove it
        if (isEmpty(stateSchedule.Schedules)) {
          data.splice(stateIndex, 1);
        }
        addScheduleInList(data, schedule);
      } else {
        Vue.set(stateSchedule.Schedules, index, schedule.Schedules[0]);
      }
    }
  });
};

const removeScheduleInList = (data, scheduleID) => {
  each(data, (stateSchedule, stateIndex) => {
    const schedules = stateSchedule ? stateSchedule.Schedules : [];
    const index = findIndex(schedules, item => Number(item.id) === Number(scheduleID));
    console.log('findIndex', index);
    if (index !== -1) {
      schedules.splice(index, 1);
      console.log('gate 2');
      if (isEmpty(schedules)) {
        console.log('gate 3');
        data.splice(stateIndex, 1);
      }
    }
  });
};

const getters = {
  ProgramDaySchedules: state => id => state[id],
};

const actions = {
  GetProgramDaySchedules({ commit }, params) {
    const id = params.id;
    const type = params.type;
    const dayID = params.dayID;

    commit(types.FETCH_PROGRAM_DAY_SCHEDULES_START, { id });
    api.getSchedules(
      type,
      id,
      dayID,
      (response) => {
        commit(types.RECEIVE_PROGRAM_DAY_SCHEDULES, { id, response });
      },
      (description, status, error) => {
        if (status === 404) {
          commit(types.FETCH_PROGRAM_DAY_SCHEDULES_NOT_FOUND, { id, error });
        } else {
          commit(types.FETCH_PROGRAM_DAY_SCHEDULES_ERROR, { id, error });
        }
      },
    );
  },
  AddProgramDaySchedule({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const dayID = params.dayID;
      const payload = params.payload;

      commit(types.ADD_PROGRAM_DAY_SCHEDULE_START, { id });
      api.addSchedule(
        type,
        id,
        dayID,
        payload,
        (response) => {
          commit(types.ADD_PROGRAM_DAY_SCHEDULE_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.ADD_PROGRAM_DAY_SCHEDULE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  EditProgramDaySchedule({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const dayID = params.dayID;
      const scheduleID = params.scheduleID;
      const payload = params.payload;

      commit(types.EDIT_PROGRAM_DAY_SCHEDULE_START, { id });
      api.editSchedule(
        type,
        id,
        dayID,
        scheduleID,
        payload,
        (response) => {
          commit(types.EDIT_PROGRAM_DAY_SCHEDULE_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.EDIT_PROGRAM_DAY_SCHEDULE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  RemoveProgramDaySchedule({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const dayID = params.dayID;
      const scheduleID = params.scheduleID;

      commit(types.REMOVE_PROGRAM_DAY_SCHEDULE_START, { id });
      api.removeSchedule(
        type,
        id,
        dayID,
        scheduleID,
        () => {
          commit(types.REMOVE_PROGRAM_DAY_SCHEDULE_SUCCESSFUL, { id, scheduleID });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.REMOVE_PROGRAM_DAY_SCHEDULE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  RemoveProgramDaySchedules({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const dayID = params.dayID;

      commit(types.REMOVE_PROGRAM_DAY_SCHEDULES_START, { id });
      api.removeDaySchedules(
        type,
        id,
        dayID,
        (response) => {
          commit(types.REMOVE_PROGRAM_DAY_SCHEDULES_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.REMOVE_PROGRAM_DAY_SCHEDULES_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  UpdateProgramDaySchedulesSequence({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const dayID = params.dayID;
      const payload = params.payload;
      api.updateSchedulesSequence(
        type,
        id,
        dayID,
        payload,
        (response) => {
          commit(types.UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearProgramDaySchedules({ commit }, { id }) {
    commit(types.CLEAR_PROGRAM_DAY_SCHEDULES_STORE, { id });
  },
};

const mutations = {
  [types.FETCH_PROGRAM_DAY_SCHEDULES_START](state, { id }) {
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_PROGRAM_DAY_SCHEDULES_ERROR](state, { id, error }) {
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.FETCH_PROGRAM_DAY_SCHEDULES_NOT_FOUND](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { notFound: true }));
  },
  [types.RECEIVE_PROGRAM_DAY_SCHEDULES](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, meta: response.meta, data: response.data }));
  },

  [types.CLEAR_PROGRAM_DAY_SCHEDULES_STORE](state, { id }) {
    Vue.set(state, id, assign({}, initState));
  },

  [types.ADD_PROGRAM_DAY_SCHEDULE_START](state, { id }) {
    if (state[id]) Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
    else Vue.set(state, id, assign({}, initState, { saving: true }));
  },
  [types.ADD_PROGRAM_DAY_SCHEDULE_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.ADD_PROGRAM_DAY_SCHEDULE_SUCCESSFUL](state, { id, response }) {
    addScheduleInList(state[id].data, response.data);
    Vue.set(state, id, assign(state[id], neutralState));
  },

  [types.EDIT_PROGRAM_DAY_SCHEDULE_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.EDIT_PROGRAM_DAY_SCHEDULE_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.EDIT_PROGRAM_DAY_SCHEDULE_SUCCESSFUL](state, { id, response }) {
    editScheduleInList(state[id].data, response.data);
    Vue.set(state, id, assign(state[id], neutralState));
  },

  [types.REMOVE_PROGRAM_DAY_SCHEDULE_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.REMOVE_PROGRAM_DAY_SCHEDULE_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.REMOVE_PROGRAM_DAY_SCHEDULE_SUCCESSFUL](state, { id, scheduleID }) {
    removeScheduleInList(state[id].data, scheduleID);
    Vue.set(state, id, assign(state[id], neutralState));
  },

  [types.REMOVE_PROGRAM_DAY_SCHEDULES_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.REMOVE_PROGRAM_DAY_SCHEDULES_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.REMOVE_PROGRAM_DAY_SCHEDULES_SUCCESSFUL](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { data: [] }));
  },

  [types.UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.UPDATE_PROGRAM_DAY_SCHEDULES_SEQUENCE_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { data: response.data }));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/programs/entities/program-day-schedules.js